import { useState } from "react";
import { toast } from "react-toastify";
import SoftButton from "components/UI/SoftButton";
import { getDownloadUrl } from "new-services";

// Opens a MinIO object through a short-lived presigned URL. Kept as a component so the
// request card and the detail modal share the same behaviour.
export default function SupportingDocumentButton({ file, label = "View Document", ...props }) {
  const [loading, setLoading] = useState(false);

  if (!file?.key) return null;

  const handleOpen = async () => {
    setLoading(true);
    try {
      const res = await getDownloadUrl(file.key);
      if (res.status_code === 200 && res.data?.download_url) {
        window.open(res.data.download_url, "_blank", "noopener,noreferrer");
      } else {
        toast.error(res.message || "Unable to open the document");
      }
    } catch (error) {
      toast.error("Unable to open the document");
    } finally {
      setLoading(false);
    }
  };

  return (
    <SoftButton
      variant="outlined"
      color="error"
      size="small"
      onClick={handleOpen}
      disabled={loading}
      sx={{ minHeight: 28, py: 0.25, px: 1, fontSize: 11 }}
      {...props}
    >
      {loading ? "Opening..." : label}
    </SoftButton>
  );
}
